exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1qrgu7iMyjKiJCOjgQTCGi{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}html[dir=ltr] ._1qrgu7iMyjKiJCOjgQTCGi,html[dir=rtl] ._1qrgu7iMyjKiJCOjgQTCGi{padding-right:12px;padding-left:12px}._1y1Sv50cBAJcCliDfhOQNF,._2h3s7huA-jdkoNsAwZL2MW{width:100%}", ""]);
// Exports
exports.locals = {
	"emptyStateContainer": "_1qrgu7iMyjKiJCOjgQTCGi",
	"container": "_1y1Sv50cBAJcCliDfhOQNF",
	"mainMessage": "_2h3s7huA-jdkoNsAwZL2MW"
};